<template lang="pug">
  .module__main
    .module__title Список выводов
    .module-content__container
      .filters__container
        .dates__container
          .date__container
            el-date-picker(
              v-model="date"
              type="datetimerange"
              range-separator="-"
              start-placeholder="От"
              end-placeholder="До"
              :picker-options="dateOptions"
            )
        .search__container
          el-select(v-model="searchMode" @change="updateDefaultSearchMode()")
            el-option(v-for="(mode, key) in searchModes" :key="`search-mode-${key}`" :label="mode.locale" :value="key")
          el-input(v-model="searchValue" :placeholder="searchModes[searchMode].title")
            i.el-input__icon.el-icon-search(slot="suffix" @click="searchOrder()")
          i.el-icon-close.search-reset__btn(v-if="searchLoaded" @click="resetSearch()")
      .control-buttons__container(v-if="canAddWithdraws")
        .new-wallet__container
          el-button(size="mini" @click="enableWithdrawAdding") Создать новый
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="formattedWithdraws"
            style="width: 100%; font-size: 12px"
          )
            el-table-column(v-if="isAdmin || isSupport" label="Пользователь" width="150")
              template(v-slot:default="scope")
                div {{ scope.row.user }}
                div(v-if="scope.row.comment") ({{ scope.row.comment }})
            el-table-column(prop="id" label="ID" width="220")
              template(v-slot:default="scope")
                div {{ scope.row.id }}
                div(v-if="scope.row.custom_id") ({{ scope.row.custom_id }})
            el-table-column(prop="address" label="Адрес" width="200")
            el-table-column(v-if="isAdmin || isSupport" prop="sourceAddress" label="Источник" width="200")
            el-table-column(prop="amount" label="Количество" width="100")
            el-table-column(label="Комиссия" width="170")
              template(v-slot:default="scope")
                div(v-if="scope.row.fee") Стоимость: {{ scope.row.fee.cost }} sat/byte
                div(v-if="scope.row.fee") Сумма: {{ scope.row.fee.amount }} {{ cryptoType }}
            el-table-column(prop="status" label="Статус" width="180")
              template(v-slot:default="scope")
                div
                  span {{ scope.row.status }}
                  span(v-if="scope.row.showError") {{ ` (${scope.row.error})` }}
                .action-buttons__container
                  el-button.action-button(v-if="scope.row.canConfirm" type="success" size="mini" @click="withdrawAction(scope.row.id, 'confirm')") Подтвердить
                  el-button.action-button(v-if="scope.row.canCancel" type="danger" size="mini" @click="withdrawAction(scope.row.id, 'cancel')") Отменить
                  el-button.action-button(v-if="scope.row.canRestart" type="warning" size="mini" @click="withdrawAction(scope.row.id, 'restart')") Перезапросить
                  el-button.action-button(v-if="scope.row.canBump" type="primary" size="mini" @click="openBumpFee(scope.row)") Повысить комиссию
            el-table-column(prop="date" label="Дата" width="150")
            el-table-column(prop="txid" label="ID транзакции" width="250")
              template(v-slot:default="scope" )
                a(v-if="scope.row.txidLink" :href="scope.row.txidLink" target="_blank") {{ scope.row.txid }}
        .table-pagination__container
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='withdraws.pagination.total',
            :page-size="per_page",
            :current-page='withdraws.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadWithdraws',
          )
    el-dialog(v-if="isAdmin" :visible.sync="isWithdrawAdding" :before-close="resetWithdrawAdding" title="Добавление вывода" width="30%")
      .dialog__container
        .dialog-input__cointaner
          .title Адрес вывода
          el-input(v-model="addingWithdraw.address" placeholder="Адрес")
        .dialog-input__cointaner
          .title Сумма вывода
          el-input(type="number" v-model="addingWithdraw.amount" placeholder="Сумма")
        .dialog-input__cointaner
          .title Дополнительный ID
          el-input(v-model="addingWithdraw.custom_id" placeholder="ID")
        .dialog-input__cointaner
          .title Код 2FA
          el-input(v-model="addingWithdraw.token_2fa" placeholder="Код 2FA")
        .dialog__buttons
          el-button(type="success" @click="requestWithdraw") Запросить
          el-button(type="danger" @click="resetWithdrawAdding()") Отменить
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  ADD_WITHDRAW,
  BUMP_WITHDRAW,
  CANCEL_WITHDRAW,
  CONFIRM_WITHDRAW,
  LOAD_WITHDRAWS_LIST,
  RESTART_WITHDRAW,
} from '@/store/const/withdraws';
import instruments from '@/mixins/instruments';
import {
  loadListFilters,
  restoreDateRange,
  saveListFilters,
} from '@/utils/listFilters';

const FILTERS_STORAGE_KEY = 'withdraws_filters';

export default {
  name: 'Withdraws',
  mixins: [instruments],
  data() {
    const filters = loadListFilters(FILTERS_STORAGE_KEY);
    const searchValue =
      typeof filters.searchValue === 'string' ? filters.searchValue : '';
    return {
      page: 1,
      per_page: 50,
      searchValue,
      searchLoaded: !!searchValue,
      searchMode: localStorage.getItem('withdraws_searchMode') || 'txid',
      intervalHandle: null,
      isFirstLoading: true,
      date: restoreDateRange(filters.date),
      dateOptions: {
        shortcuts: [
          {
            text: 'Сегодня',
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              start.setHours(0, 0, 0, 0);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Сутки',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Вчера',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(start.getDate() - 1);
              start.setHours(0, 0, 0, 0);
              end.setDate(end.getDate() - 1);
              end.setHours(23, 59, 59, 999);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Неделя',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: 'Месяц',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '3 месяца',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
      isWithdrawAdding: false,
      addingWithdraw: {
        custom_id: '',
        address: '',
        amount: 0,
        token_2fa: '',
      },
      bumpFee: 50,
    };
  },
  async mounted() {
    await this.loadWithdraws();
    this.isFirstLoading = false;
    this.startInterval();
  },
  beforeDestroy() {
    this.saveFilters();
    this.stopInterval();
  },
  computed: {
    ...mapGetters(['loading', 'error']),
    ...mapGetters('settings', ['cryptoType']),
    ...mapGetters('withdraws', ['withdraws', 'statuses']),
    ...mapGetters('user', [
      'isAdmin',
      'isSuperadmin',
      'isSupport',
      'username',
      'canAddWithdraws',
    ]),
    isLoading() {
      return (
        this.isFirstLoading && this.loading(LOAD_WITHDRAWS_LIST) === 'loading'
      );
    },
    isError() {
      return this.loading(LOAD_WITHDRAWS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_WITHDRAWS_LIST);
    },
    hasPagination() {
      return this.withdraws.pagination.total > this.per_page;
    },
    searchModes() {
      const modes = {
        txid: { locale: 'По транзакции', title: 'ID транзакции' },
        id: { locale: 'По ID вывода', title: 'ID вывода' },
        address: { locale: 'По кошельку', title: 'Адрес кошелька' },
        custom_id: { locale: 'По custom_id', title: 'ID вывода' },
      };
      if (this.isAdmin || this.isSupport) {
        modes.user = { locale: 'По клиенту', title: 'Имя пользователя' };
      }
      return modes;
    },
    dates() {
      if (Array.isArray(this.date)) {
        const from = new Date(this.date[0]);
        const to = new Date(this.date[1]);
        from.setMinutes(from.getMinutes() - from.getTimezoneOffset()); // SET TO UTC 0
        to.setMinutes(to.getMinutes() - to.getTimezoneOffset()); // SET TO UTC 0
        from.setMinutes(from.getMinutes() - 180); // SET TO UTC +3
        to.setMinutes(to.getMinutes() - 180); // SET TO UTC +3
        return {
          from: from.getTime(),
          to: to.getTime(),
        };
      } else {
        return null;
      }
    },
    formattedWithdraws() {
      return this.withdraws.list.map((withdraw) => {
        const date = new Date(withdraw.createdAt);
        return {
          ...withdraw,
          status: withdraw.confirmed
            ? 'Подтвержден ✔'
            : this.statuses[withdraw.status] || withdraw.status,
          showError:
            ['error', 'review'].includes(withdraw.status) && !!withdraw.error,
          date: date.toLocaleString(),
          canConfirm:
            (this.isAdmin || this.isSupport) && withdraw.status === 'checking',
          canCancel:
            (this.isAdmin || this.isSupport) &&
            (withdraw.status === 'checking' || withdraw.status === 'wait'),
          canRestart:
            (this.isAdmin || this.isSupport) && withdraw.status === 'error',
          canBump:
            (this.isAdmin || this.isSupport) &&
            withdraw.status === 'success' &&
            !withdraw.confirmed,
          txidLink: withdraw.txid
            ? `https://live.blockcypher.com/${this.cryptoType.toLowerCase()}/tx/${withdraw.txid}/`
            : '',
        };
      });
    },
  },
  methods: {
    ...mapActions('withdraws', {
      loadWithdrawsList: LOAD_WITHDRAWS_LIST,
      addWithdraw: ADD_WITHDRAW,
      confirmWithdraw: CONFIRM_WITHDRAW,
      restartWithdraw: RESTART_WITHDRAW,
      bumpWithdraw: BUMP_WITHDRAW,
      cancelWithdraw: CANCEL_WITHDRAW,
    }),
    saveFilters() {
      saveListFilters(FILTERS_STORAGE_KEY, {
        searchValue: this.searchValue,
        date: this.date,
      });
    },
    startInterval() {
      this.stopInterval();
      this.intervalHandle = setInterval(
        () => this.loadWithdraws(this.page),
        10000,
      );
    },
    stopInterval() {
      if (this.intervalHandle) {
        clearInterval(this.intervalHandle);
        this.intervalHandle = null;
      }
    },
    async loadWithdraws(page = 1) {
      if (this.isLoading) {
        return;
      }
      const params = {
        page,
        per_page: this.per_page,
      };
      if (this.searchValue) {
        params[this.searchMode] = this.searchValue;
      }
      if (this.date) {
        params.from = this.dates.from;
        params.to = this.dates.to;
      }
      await this.loadWithdrawsList({ params });
      this.page = page;
      this.searchLoaded = !!this.searchValue;
    },
    async searchOrder() {
      this.stopInterval();
      this.searchValue = this.searchValue.trim();
      await this.loadWithdraws(1);
    },
    async reloadWithdraws() {
      this.stopInterval();
      await this.loadWithdraws(1);
      this.startInterval();
    },
    resetSearch() {
      this.searchLoaded = false;
      this.searchValue = '';
      this.reloadWithdraws();
    },
    updateDefaultSearchMode() {
      localStorage.setItem('withdraws_searchMode', this.searchMode);
    },
    enableWithdrawAdding() {
      this.isWithdrawAdding = true;
    },
    resetWithdrawAdding() {
      this.isWithdrawAdding = false;
      this.addingWithdraw.custom_id = '';
      this.addingWithdraw.address = '';
      this.addingWithdraw.amount = 0;
      this.addingWithdraw.token_2fa = '';
    },
    async resetWithdrawAddingAndLoadWithdraws() {
      this.resetWithdrawAdding();
      await this.loadWithdraws(this.page);
    },
    async requestWithdraw() {
      if (!this.addingWithdraw.address || !this.addingWithdraw.amount) {
        return this.$message.warning('Не указан адрес или сумма вывода');
      }
      const request = await this.addWithdraw(this.addingWithdraw);
      await this.notifyRequestResult({
        request,
        successMessage: 'Вывод успешно добавлен',
        methodOnSuccess: this.resetWithdrawAddingAndLoadWithdraws,
      });
    },
    openBumpFee(withdraw) {
      const message = `Укажите добавочную стоимость ускорения (sat/byte). Текущая стоимость: ${(withdraw.fee || {}).cost} sat/byte. Текущая комиссия: ${(withdraw.fee || {}).amount} ${this.cryptoType}.`;
      this.$prompt(message, 'Ускорение вывода', {
        confirmButtonText: 'Ускорить',
        cancelButtonText: 'Отмена',
        inputType: 'number',
        inputValue: this.bumpFee,
        inputErrorMessage: 'Ошибка ускорения',
      })
        .then(({ value }) => {
          if (!value) {
            return this.$message.warning('Укажите стоимость');
          }
          return this.$prompt('Введите код 2FA', 'Проверка безопасности', {
            confirmButtonText: 'Ускорить',
            cancelButtonText: 'Отмена',
          }).then(({ value: token }) => {
            this.withdrawAction(withdraw.id, 'bump', { fee: value }, token);
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Input canceled',
          });
        });
    },
    async withdrawAction(id, type, params, token_2fa) {
      const allowedActionTypes = ['confirm', 'restart', 'bump', 'cancel'];
      if (!allowedActionTypes.includes(type)) {
        return this.$message.warning(
          `Неизвестный тип действия для вывода: ${type}`,
        );
      }
      let typeLocale = '';
      let action;
      switch (type) {
        case 'confirm':
          typeLocale = 'подтвердить';
          action = this.confirmWithdraw;
          break;
        case 'restart':
          typeLocale = 'перезапустить';
          action = this.restartWithdraw;
          break;
        case 'bump':
          typeLocale = 'ускорить';
          action = this.bumpWithdraw;
          break;
        case 'cancel':
          typeLocale = 'отменить';
          action = this.cancelWithdraw;
          break;
      }

      this.$confirm(
        `Вы уверены, что хотите ${typeLocale} вывод ${id}?`,
        'Подтверждение',
      )
        .then(async () => {
          const request = await action({ id, params, token_2fa });
          await this.notifyRequestResult({
            request,
            successMessage: 'Вывод успешно изменен',
          });
        })
        .catch(() => {
          this.$message.info('Изменение отменено');
        });
    },
  },
};
</script>
<style scoped>
.filters__container {
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
  border: 1px solid #c9c9c9;
}

.search__container {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-left: auto;
}

.search-reset__btn {
  padding: 11px;
  background-color: #e95050;
  cursor: pointer;
}

.search-reset__btn:hover {
  padding: 10px;
  background-color: #dd3636;
  border: 1px solid #850202;
}

.search__container .el-select {
  width: 250px;
}

.dates__container {
  display: flex;
  align-items: center;
}

.date__container {
  margin: 0 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.control-buttons__container {
  margin-bottom: 5px;
}

.action-buttons__container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.action-button {
  width: 100%;
  margin: 2px auto !important;
}
</style>
